import axios from 'axios'
import { WX } from './custom'
import { analytics, Asset, BusinessCard, CompanyInfo, Menu } from './api/backend'

const iconUrl = (url: string) => `${url}?imageMogr2/thumbnail/32x`

export const setupWX = async (url: string, card: BusinessCard, companyInfo: CompanyInfo) => {
  const jsApiList = [
    'checkJsApi',
    'openAddress',
    'openLocation',
    'showMenuItems',
    'onMenuShareAppMessage',
    'onMenuShareTimeline'
  ]
  try {
    const res = await axios.get('/open/api/wx/api/signature', {
      params: { url }
    })
    if (res.status === 200 && res.data.code === 200) {
      const config: WX.InitConfig = res.data.data
      wx.config({
        ...config,
        jsApiList,
        debug: false,
        openTagList: ['wx-open-launch-weapp'],
      })
      wx.ready(() => {
        const { businessCardId } = card
        const { squareLogo } = companyInfo
        const { title } = window.document
        wx.onMenuShareAppMessage({
          title,
          imgUrl: iconUrl(squareLogo),
          desc: '百格活动提供一站式活动会议管理服务，全面提升会议品质与办会效率。',
          link: url,
          success: e => {
            console.log('share app success', e)
            analytics.track('SHARE', {
              business_card_id: businessCardId,
              title
            })
          }
        })
        // wx.onMenuShareTimeline({})
        wx.showMenuItems({
          menuList: [
            "menuItem:share:appMessage",
            "menuItem:share:timeline",
            "menuItem:share:qq"
          ]
        })
      })
      wx.error(res => {
        console.log(res)
      })
    }
  } catch (e) {
    console.log(e)
  }
}

export const changeFavIcon = (url: string) => {
  const original = document.querySelector<HTMLLinkElement>("link[rel*='icon']")
  const link = original ?? document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = iconUrl(url)
  document.getElementsByTagName('head')[0].appendChild(link)
}

export const changeTheme = (colorString: string) => {
  const original = document.querySelector<HTMLMetaElement>("meta[name='theme-color']")
  const theme = original ?? document.createElement('meta')
  theme.content = colorString
  document.getElementsByTagName('head')[0].appendChild(theme)
}

export type TitleSource = BusinessCard | Asset | Menu | undefined
export const changeTitle = (obj: TitleSource, companyName: string) => {
  if (obj) {
    let title
    if ('businessCardId' in obj) {
      title = `${obj.userName}@${companyName}`
    } else if ('assertId' in obj) {
      title = `${obj.assertName}-${companyName}`
    } else {
      title = `${obj.menuName}-${companyName}`
    }
    if (window.document.title !== title) {
      window.document.title = title
    }
  }
}
